import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Rutas protegidas para el panel admin.
 * Props:
 *   - require: string | string[]   → permiso(s) requerido(s). Basta con tener uno.
 *   - fallback: ruta a la que redirigir si no tiene permisos (default: /admin)
 */
export default function ProtectedRoute({ children, require, fallback = "/admin" }) {
  const { user, checking, hasAnyPerm } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-lightgray">
        <div className="text-xs uppercase tracking-[0.24em] text-textgray">Cargando panel…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  // Force password change if required
  if (user.must_change_password && location.pathname !== "/admin/cambiar-contrasena") {
    return <Navigate to="/admin/cambiar-contrasena" replace />;
  }

  if (require) {
    const codes = Array.isArray(require) ? require : [require];
    if (!hasAnyPerm(...codes)) {
      return (
        <Navigate
          to={fallback}
          replace
          state={{ deniedFrom: location.pathname, requiredPerm: codes }}
        />
      );
    }
  }

  return children;
}
